import { render } from "./ChevronDownIcon.vue?vue&type=template&id=7a9354d0"
const script = {}
script.render = render

export default script